import { TextField, styled } from "@mui/material";
import theme from "../../../theme";
import { jsx as _jsx } from "react/jsx-runtime";
var StyledTextField = styled(TextField)({ '&.MuiTextField-root .Mui-focused fieldset': {
        // width: '500px'
        borderColor: theme.palette.rnSteel.steel700
    } });
export var TextBoxComponent = function (_ref) { var id = _ref.id, value = _ref.value, placeholder = _ref.placeholder; return /*#__PURE__*/ _jsx(StyledTextField, { id: id, value: value, placeholder: placeholder }); };
